import { RegistryItem } from '../RegistryItem';
export class ConditionRegistryItem extends RegistryItem {
    parent;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    eval;
    scope;
    modifyContext; // ((p: ConditionEvaluatorContext) => object);
    params;
}
